export const CLOCK_CONNECT_TIMEOUT_MS = 15000;
export const PROBE_JITTER_RATIO = 0.1;
export const PROBE_SCHEDULE_MS = [
  ...Array(5).fill(60000),
  ...Array(3).fill(120000),
  ...Array(3).fill(300000),
  ...Array(2).fill(600000),
];
export const PROBE_FINAL_DELAY_MS = 900000;
